import { render, staticRenderFns } from "./addCommercialStory.vue?vue&type=template&id=cdd73e62"
import script from "./addCommercialStory.vue?vue&type=script&lang=js"
export * from "./addCommercialStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports